export default "__VITE_ASSET__CSvWJniz__"